import store from '@/store/index.js';
import * as deviceStateUtils from './state';
import { isArray, isEmpty, isNullOrUnDef, isObject, isString } from '@/utils/is';
import ctt from '@/utils/const';
import { nodeTypeEnum } from './dict';
import { arrify } from '../utils';

/**
 * PI显示约化
 * 表中显示的PID的值、以及PID曲线上的pidThreshold阈值参数需要进行约化
 * @param {Number} pidValue pid实时值
 * @param {Number} basal 基础值
 * @returns {Number} 约化后值 保留小数点后2为
 */
export const pidReduction = (pidValue, basal) => {
  if (isNaN(pidValue) || pidValue < basal) return 0;
  const pidRed = (pidValue - 70) / 80;
  return parseFloat(Number(pidRed).toFixed(2));
};

/**
 * 获取设备类型信息
 * @param {string} deviceType
 */
export function getDeviceTypeInfo(deviceType) {
  const deviceTypeInfo = store.state.device.deviceTypeInfo;
  if (!isObject(deviceTypeInfo)) return;
  const info = deviceTypeInfo[deviceType];
  return info;
}

/**
 * 获取设备类型图片
 * @param {string} deviceType
 * @returns {{ picture: string, thumbnail: string }}
 */
export function getDeviceTypeImg(deviceType) {
  const info = getDeviceTypeInfo(deviceType);
  const defaultImg = {
    picture: '/static/image/device/device-default.png',
    thumbnail: '/static/image/device/device-default.png'
  };
  if (isNullOrUnDef(info)) return defaultImg;
  const img = info && info.pictures;
  if (isEmpty(img) || !isString(img)) return defaultImg;
  return Object.assign(defaultImg, JSON.parse(img));
}

/**
 * 判断是否是监测类设备
 * @param {1|2} mode
 * @returns {boolean}
 */
export function isMonitorDevice(mode) {
  return mode === ctt.MONITOR_DEVICE;
}

/**
 * 判断是否是检测类设备
 * @param {1|2} mode
 * @returns {boolean}
 */
export function isDetectDevice(mode) {
  return mode === ctt.DETECT_DEVICE;
}

/**
 * 判断nodeType 是设备
 * @param {number} nodeType
 */
export function isDevice(nodeType) {
  return nodeTypeEnum.DEVICE === nodeType;
}

/**
 * 判断nodeType 是机构
 * @param {number} nodeType
 */
export function isOffice(nodeType) {
  return nodeTypeEnum.OFFICE === nodeType;
}

/**
 * 获取指定设备树下所有设备
 * @param {Array<any>} list
 */
export function extDevice(list) {
  const res = [];
  function loop(_list) {
    _list.forEach(e => {
      if (isEmpty(e)) return;
      if (isOffice(e.nodeType)) {
        if (isArray(e.children) && !isEmpty(e.children)) {
          loop(e.children);
        }
      } else {
        res.push(e);
      }
    });
  }
  loop(arrify(list));
  return res;
}

export function extDeviceParentIds({ id, nodeType }, data) {
  if (isEmpty(id) || isEmpty(data)) return [];
  const res = [];

  if (isOffice(nodeType)) res.push(id);

  function loop(id) {
    const parentId = (data[id] || {}).parentId;
    if (isEmpty(parentId) || isEmpty(data[parentId])) return;
    res.push(parentId);
    loop(parentId);
  }
  loop(id);
  return res;
}

export { deviceStateUtils };
